import { api } from '../serverClient';

export async function fetchLibraryDecks({ tab = 'all', sort = 'latest', search, avatar, type, limit = 20, offset = 0 } = {}) {
  const params = new URLSearchParams();
  params.set('tab', tab);
  params.set('sort', sort);
  if (search) params.set('search', search);
  if (avatar) params.set('avatar', avatar);
  if (type && type !== 'all') params.set('type', type);
  params.set('limit', String(limit));
  params.set('offset', String(offset));
  return api.get(`/decks/library?${params}`);
}

// One shared deck in the same shape as a fetchLibraryDecks row. Backs
// notification deep links ("X commented on your deck"). 404s once the
// deck is no longer shared.
export async function fetchLibraryDeck(deckId) {
  return api.get(`/decks/library/${encodeURIComponent(deckId)}`);
}

export async function shareDeck(deckId) {
  return api.post(`/decks/${encodeURIComponent(deckId)}/share`, {});
}

export async function unshareDeck(deckId) {
  return api.delete(`/decks/${encodeURIComponent(deckId)}/share`);
}

export async function toggleDeckLike(deckId) {
  return api.post(`/decks/${encodeURIComponent(deckId)}/like`, {});
}

export async function recordDeckView(deckId) {
  return api.post(`/decks/${encodeURIComponent(deckId)}/view`, {});
}

export async function saveDeckFromLibrary(deckId) {
  return api.post(`/decks/${encodeURIComponent(deckId)}/save`, {});
}

export async function fetchDeckComments(deckId, { sort = 'recent' } = {}) {
  const params = new URLSearchParams();
  params.set('sort', sort);
  return api.get(`/decks/${encodeURIComponent(deckId)}/comments?${params}`);
}

export async function postDeckComment(deckId, body, { quotedText } = {}) {
  const payload = { body };
  if (quotedText) payload.quotedText = quotedText;
  return api.post(`/decks/${encodeURIComponent(deckId)}/comments`, payload);
}

export async function deleteDeckComment(deckId, commentId) {
  return api.delete(`/decks/${encodeURIComponent(deckId)}/comments/${encodeURIComponent(commentId)}`);
}

export async function toggleDeckCommentLike(deckId, commentId) {
  return api.post(`/decks/${encodeURIComponent(deckId)}/comments/${encodeURIComponent(commentId)}/like`, {});
}
